import { ActionButton } from "#/components/shared/buttons/ActionButtons";

export type MessageTemplatesPaginationProps = {
  page: number;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
  isLoading?: boolean;
};

export function MessageTemplatesPagination({
  page,
  hasNext,
  onPrevious,
  onNext,
  isLoading = false,
}: MessageTemplatesPaginationProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <span className="text-sm text-brown-600">Page {page}</span>
      <div className="flex items-center gap-2">
        <ActionButton
          tone="secondary"
          size="sm"
          onClick={onPrevious}
          disabled={page <= 1 || isLoading}
        >
          Previous
        </ActionButton>
        <ActionButton
          tone="secondary"
          size="sm"
          onClick={onNext}
          disabled={!hasNext || isLoading}
        >
          Next
        </ActionButton>
      </div>
    </div>
  );
}

export default MessageTemplatesPagination;
